export default __webpack_public_path__ + "static/media/fam1.65fdb433.png";